import { render, staticRenderFns } from "./MaterialOrderItems.vue?vue&type=template&id=1fc72f9a&scoped=true"
import script from "./MaterialOrderItems.vue?vue&type=script&lang=js"
export * from "./MaterialOrderItems.vue?vue&type=script&lang=js"
import style0 from "./MaterialOrderItems.vue?vue&type=style&index=0&id=1fc72f9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc72f9a",
  null
  
)

export default component.exports